import { expressionDefinitionApiV2, miRulesCriteriaApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const MI_RULES_CRITERIA_ACTION_TYPE = createNamedActions('miRules', {
  GET_CRITERIA: 'GET_CRITERIA',
  GET_CRITERIA_SCHEMA: 'GET_CRITERIA_SCHEMA',
  CREATE_CRITERIA: 'CREATE_CRITERIA',
  EDIT_CRITERIA: 'EDIT_CRITERIA',
  DELETE_CRITERIA: 'DELETE_CRITERIA',
  DISABLE_GLOBAL_RULE: 'DISABLE_GLOBAL_RULE',
  ENABLE_GLOBAL_RULE: 'ENABLE_GLOBAL_RULE',
  CLONE_GLOBAL_RULE: 'CLONE_GLOBAL_RULE',
});

const criteria = new schema.Entity('criteria', {}, { idAttribute: 'ruleId' });

export const getMIRulesCriteriaAction = catchAsyncActionError(
  ({ snapshotId }) =>
    async dispatch => {
      const { data } = await miRulesCriteriaApi.getCriteria({ snapshotId });

      return dispatch({
        type: MI_RULES_CRITERIA_ACTION_TYPE.GET_CRITERIA,
        payload: normalize(data, [criteria]).entities.criteria,
      });
    },
);

export const createMIRulesCriteriaAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await miRulesCriteriaApi.createCriteria(params);

  return dispatch({
    type: MI_RULES_CRITERIA_ACTION_TYPE.CREATE_CRITERIA,
    payload: data,
  });
});

export const editMIRulesCriteriaAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await miRulesCriteriaApi.editCriteria(params);

  return dispatch({
    type: MI_RULES_CRITERIA_ACTION_TYPE.EDIT_CRITERIA,
    payload: data,
  });
});

export const deleteMIRulesCriteriaAction = catchAsyncActionError(params => async dispatch => {
  await miRulesCriteriaApi.deleteCriteria(params);

  return dispatch({
    type: MI_RULES_CRITERIA_ACTION_TYPE.DELETE_CRITERIA,
    meta: params,
  });
});

export const disableGlobalMiRuleAction = catchAsyncActionError(params => async dispatch => {
  await miRulesCriteriaApi.disableGlobalMiRule(params);

  return dispatch({
    type: MI_RULES_CRITERIA_ACTION_TYPE.DISABLE_GLOBAL_RULE,
    meta: params,
  });
});

export const enableGlobalMiRuleAction = catchAsyncActionError(params => async dispatch => {
  await miRulesCriteriaApi.enableGlobalMiRule(params);

  return dispatch({
    type: MI_RULES_CRITERIA_ACTION_TYPE.ENABLE_GLOBAL_RULE,
    meta: params,
  });
});

export const cloneGlobalMiRuleAction = catchAsyncActionError(params => async dispatch => {
  await miRulesCriteriaApi.cloneGlobalMiRule(params);

  return dispatch({
    type: MI_RULES_CRITERIA_ACTION_TYPE.CLONE_GLOBAL_RULE,
    meta: params,
  });
});

export const getMIRulesSchemaParamsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await expressionDefinitionApiV2.getMiRulesExpressionDefinition();

  return dispatch({
    type: MI_RULES_CRITERIA_ACTION_TYPE.GET_CRITERIA_SCHEMA,
    payload: data,
  });
});
